/**
 * Swatch grid for selecting a child's colour.
 * 12 colours displayed as a single flat grid.
 */
import { CHILD_COLORS } from "@/config/childColors";

interface ChildColorPickerProps {
  value: string;
  onChange: (hex: string) => void;
}

export default function ChildColorPicker({ value, onChange }: ChildColorPickerProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {CHILD_COLORS.map((color) => {
        const selected = value === color.hex;
        return (
          <button
            key={color.hex}
            type="button"
            title={color.label}
            onClick={() => onChange(color.hex)}
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: color.hex,
              border: "none",
              padding: 0,
              cursor: "pointer",
              boxShadow: selected
                ? `0 0 0 2px white, 0 0 0 4px ${color.hex}`
                : "0 0 0 1.5px rgba(0,0,0,0.08)",
              transform: selected ? "scale(1.15)" : "scale(1)",
              transition: "transform 150ms ease, box-shadow 150ms ease",
            }}
          />
        );
      })}
    </div>
  );
}
